import { render, staticRenderFns } from "./ReporteValidaciones.vue?vue&type=template&id=084649bc&"
import script from "./ReporteValidaciones.vue?vue&type=script&lang=js&"
export * from "./ReporteValidaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports